// extracted by mini-css-extract-plugin
export default {"cancelButton":"cancel-button_cancelButton__XoPAQ"};